/* eslint-disable no-throw-literal */
import React, { useEffect, useState } from "react";
import "../App.scss";
import { headerDisplaying, footerDisplaying } from "../store/mainSlice";
import LogoActiveAndFreefit from "../img/ff_and_active_logo_colored.png";
import LogoWowAndFreefit from "../img/ff_and_wow_logo_colored.png";
import LogoOvdimBari from "../img/ovdim_bari_logo_colored.png";
import { useSelector, useDispatch } from "react-redux";
import { updateMainUserData, updateUserData } from "../store/userSlice";
import swalDialog from "../helpers/swalErrorPopup";
import { useNavigate } from "react-router-dom";
import { isLoadChanger } from "../store/mainSlice";
import { useTranslation } from "react-i18next";
import userAPI from "../api/userAPI";
import Footer from "../components/Footer";
import { validateEmail } from "../utils/helper";
import { isPartnerClalit, isPartnerOvdimBari, isPartnerMaoflaamit, selectPartner } from "../store/partnerStore";
import { isV2Enabled, V2_SCREEN_KEYS } from "../v2/registry";
import AddEmailV2 from "../v2/screens/addEmail/AddEmail";

const Registration = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isClalit = useSelector(isPartnerClalit);
  const isOvdimBari = useSelector(isPartnerOvdimBari);
  const isMaoflaamit = useSelector(isPartnerMaoflaamit);
  const partner = useSelector(selectPartner);
  const [email, setEmail] = useState("");
  const [invalidEmail, setInvalidEmail] = useState(true);
  const mainUserData = useSelector((state) => state.userSlice.mainUserData);
  const userToken = useSelector((state) => state.userSlice.userToken);
  const showHealthForm = useSelector((state) => state.userSlice.showHealthForm);

  useEffect(() => {
    dispatch(headerDisplaying(false));
    dispatch(footerDisplaying(false));
    return () => {
      dispatch(headerDisplaying(true));
    };
  }, []);

  const submitEmail = async (email) => {
    if (!validateEmail(email)) {
      setInvalidEmail(true);
      return;
    }

    try {
      dispatch(isLoadChanger(true));

      await userAPI.updateClientEmailByMobile({
        token: mainUserData.Token,
        id: mainUserData.ID,
        phone: mainUserData.Phone,
        email: email,
      });

      // The endpoint answers with an { Error, Message, Data } ack, not a user object, and
      // updateMainUserData replaces wholesale — spreading the response here wiped Token/ID/Phone
      // and left every credential-gated fetch (home carousels, prices, passes) blocked until a
      // hard refresh re-ran the handshake. Keep the handshake payload, patch only what changed.
      dispatch(updateMainUserData({ ...mainUserData, Email: email }));
      const allUserParams = await userAPI.login({
        Token: userToken,
        ID: mainUserData.ID,
        Phone: mainUserData.Phone,
      });

      dispatch(updateUserData(allUserParams));

      // Registration only happens with an empty email — always the first
      // onboarding — so both exits mark the chain as onboarding: the questionnaire
      // passes it on via state, and the direct exit is the welcome intro (which is
      // also the location gate).
      if (showHealthForm) {
        navigate("/registrationQuestionnaire", { state: { fromOnboarding: true } });
      } else {
        navigate("/welcome");
      }

      dispatch(isLoadChanger(false));
    } catch (err) {
      dispatch(isLoadChanger(false));
      swalDialog(err);
    }
  };

  // V2 add-email page. submitEmail above still owns the save + login + navigation.
  if (isV2Enabled(V2_SCREEN_KEYS.REGISTRATION, partner))
    return <AddEmailV2 fullName={mainUserData?.FullName ?? ""} onSubmit={submitEmail} />;

  return (
    <div className="registration-wrapper">
      <div className="registration-logo-container">
        <img
          src={isClalit ? LogoActiveAndFreefit : isOvdimBari || isMaoflaamit ? LogoOvdimBari : LogoWowAndFreefit}
          alt="logo"
          style={isClalit ? { width: "140px" } : isOvdimBari || isMaoflaamit ? { width: "65px" } : { width: "60px" }}
        />
      </div>
      <div className="registration-content-container">
        <div className="registration-input-container">
          {isClalit ? (
            <h3>
              {t("HEY")} {mainUserData?.FullName ?? ""},
            </h3>
          ) : (
            <h3>{t("LAST_STEP_BEFORE_START")}</h3>
          )}
          <p>{t("EMAIL_REQUIRED")}</p>
        </div>

        <div className="registration-input-and-btn-container">
          <input
            type="text"
            placeholder={t("EMAIL_PLACEHOLDER")}
            onChange={(e) => {
              setInvalidEmail(false);
              setEmail(e.target.value);
            }}
            className={email ? "ltr" : "rtl"}
          />
          <button
            className={`registration-btn ${invalidEmail || email === "" ? "disabled" : ""}`}
            onClick={() => submitEmail(email)}
          >
            {t("CONTINUE")}
          </button>
        </div>
      </div>
      {isClalit && (
        <footer className="sidebar-footer-wrapper">
          <div className="sidebar-info">
            <p className="sidebar-info-text">{t("PRIVACY_POLICY")}</p>
            <p className="sidebar-info-text-dot">&#8226;</p>
            <p className="sidebar-info-text">{t("TERMS_OF_USE")}</p>
          </div>
        </footer>
      )}
      <Footer />
    </div>
  );
};

export default Registration;
